export default __webpack_public_path__ + "static/media/level_inactive.162c9e8c.svg";